import { Injectable } from '@angular/core';
import { AnalyticsEventEnum } from '@whetstoneeducation/hero-common';
import { BaseService } from '../base-classes/base.service';
import { AppClientDataService } from './client-data-service/app-client-data.service';
import { logger } from '../logger';

@Injectable({
  providedIn: 'root'
})
export class AppAnalyticsService extends BaseService {
  constructor(private clientDataService: AppClientDataService) {
    super();
  }

  /**
   * Telemetry must never change what the user sees, so the call is not awaited
   * and a failure is logged instead of surfaced.
   */
  public track(event: AnalyticsEventEnum, reactionEntryId: number): void {
    if (!reactionEntryId) return;

    this.clientDataService
      .execute(this.POST_ROUTES.ANALYTICS_TRACK, {
        method: this.METHOD.POST,
        body: { event, reactionEntryId }
      })
      .catch((error) => logger.error(error));
  }
}
